export function ErrorCodeIconSrc(error: string): string {
  switch (error) {
    case 'ITEM-DIMENSIONS':
      return '/theme/icons/MaxDimensions.svg';
    case 'PRODUCT-TARIFFCODE-REQUIRED':
    case 'PRODUCT-TARIFFCODE-TOO-SHORT':
      return '/theme/icons/Customs.svg';
    default:
  }

  if (error.startsWith('ADDRESS-')) {
    return '/theme/icons/Account.svg';
  }

  if (error.startsWith('PRODUCT-') || error.startsWith('ITEM-')) {
    return '/theme/icons/Parcel.svg';
  }

  return '/theme/icons/EnquiryExclamation.svg';
}
